const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: '#1e1e2d',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
}



export default style
